import React from "react";
import classnames from "classnames";

import { usePauseInternet } from "../../../pauseInternet/PauseInternetProvider";
import {
  PauseInternetOptions,
  useUnpauseCallback,
} from "../../../pauseInternet/PauseInternet";
import { Button } from "../../../button/Button";
import { PausedInternetTimeLeft } from "../../../pauseInternet/PausedInternetTimeLeft";

import "./ProfileCardPauseInternet.scss";

export const ProfileCardPauseInternet = ({ profileName, hiddenLabel }) => {
  const { isInternetPaused, timeLeft, pauseInternet, pauseInternetOptions } =
    usePauseInternet();
  const onUnpause = useUnpauseCallback(profileName);

  const isPaused = isInternetPaused && timeLeft;

  return (
    <div
      className={classnames("profile-card-pause-internet", {
        "profile-card-pause-internet--paused": isPaused,
      })}
    >
      {isPaused ? (
        <Button
          size="large"
          variant="inverted"
          color="danger"
          onClick={onUnpause}
          ellipsis={false}
        >
          <PausedInternetTimeLeft />
        </Button>
      ) : (
        <PauseInternetOptions
          onPauseInternet={pauseInternet}
          options={pauseInternetOptions}
          hiddenLabel={hiddenLabel}
        />
      )}
    </div>
  );
};
